const component = require('../component/component');

const editList = Object.assign({}, component, {
    subelements: {
        listItemsHolder: false,
        deleteWarning: false,
    },
    enableAdd: true,
    enableRemove: true,
    enableSort: false,
    minEntries: 0,
    maxEntries: 0,
    listItems: [],
    lastIndex: -1,
    listItemTemplate: '',
    sortable: false,

    init: function () {
        component.init.call(this);

        this.initListActions(document);

        let listItems = document.querySelectorAll('[data-zit-list-item-for="' + this.id + '"]');

        listItems.forEach((listItemElement) => {
            let itemIndex = parseInt(listItemElement.dataset.zitItemIndex);
            if (itemIndex > this.lastIndex) {
                this.lastIndex = itemIndex;
            }
            let listItem = {
                index: itemIndex,
                element: listItemElement,
                subComponents: this.hm.app.elementSubComponents(listItemElement)
            };
            this.listItems.push(listItem);
        });

        this.listItemTemplate = this.getTemplate('listItem');
    },

    inited: function () {
        component.inited.call(this);

        while (this.listItems.length < this.minEntries) {
            this.add(-1);
        }

        if (this.enableSort) {
            this.initSortable();
        }
    },

    initSortable: function () {
        // .draggable / .draggable-handle: selectors for the third-party Shopify
        // Draggable library — intentionally un-prefixed (vendored _draggable.scss
        // styles them + the library emits sibling draggable-* classes we can't
        // rename). See scripts/behaviors.contract.md "Documented exception".
        this.sortable = new Draggable.Sortable(this.subelements.listItemsHolder, {
            draggable: ".draggable",
            handle: ".draggable .draggable-handle",
            mirror: {
                //appendTo: selector,
                appendTo: "body",
                constrainDimensions: true
            }
        });

        this.sortable.on('sortable:start', (e) => { this.clearTimer('saveSort_' + this.id); });

        this.sortable.on("sortable:stop", (e) => {
            this.startTimer('saveSort_' + this.id, () => { this.saveSort(); }, 2500);
            //e.data.oldIndex
            //e.data.newIndex
            //e.data.dragEvent.data.source
        });
    },

    initListActions: function (parent) {
        let addButtons = parent.querySelectorAll('[data-zit-add-button-for="' + this.id + '"]');

        addButtons.forEach((addButton) => {
            addButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.add(parseInt(addButton.dataset.zitAfterIndex));
            });
        });

        let removeButtons = parent.querySelectorAll('[data-zit-remove-button-for="' + this.id + '"]');

        removeButtons.forEach((removeButton) => {
            removeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.remove(parseInt(removeButton.dataset.zitRemoveIndex));
            });
        });
    },

    add: function (afterIndex) {
        if (this.maxEntries > 0 && this.listItems.length >= this.maxEntries) {
            let maxReachedMessage = {
                type: 'info',
                text: 'maxNoOfItemsReached'
            };
            this.hm.msgs.show(maxReachedMessage);
            return false;
        }

        // -2 beginning
        // -1 end
        let afterElement = false;

        if (afterIndex >= 0) {
            for (let i = 0; i < this.listItems.length; i++) {
                if (this.listItems[i].index === afterIndex) {
                    afterElement = this.listItems[i].element;
                    break;
                }
            }

            if (afterElement === false) {
                this.hm.warn('list item with index ' + afterIndex + ' not found');
                return false;
            }
        }

        this.lastIndex++;

        let newItemHTML = this.listItemTemplate.replace(/__samplekey__/g, this.lastIndex);
        let newListItemElement = this.hm.helper.string2element(newItemHTML);
        let newListItem = {
            index: this.lastIndex,
            element: newListItemElement,
            subComponents: []
        };

        // Bridge the inserted subtree's zit-namespaced markup onto the tier's
        // framework-namespaced equivalents (zb5 mirrors data-zit-toggle="collapse"
        // and data-zit-collapse-target onto data-bs-* so Bootstrap's collapse
        // click handler picks up subsequent user toggles). The boot-time bridge
        // didn't see this subtree because it was just stamped from a template.
        this.hm.behaviors.bridgeTierAttrs(newListItemElement);

        // Apply the tier's collapse root + initial-state classes to the new
        // item's inner collapsible body region (the [data-zit-collapsible]
        // wrapper stamped from the listItem template). The boot-time
        // createInstances scan only walked `document` and never saw this
        // subtree (a <template>'s content lives in a detached fragment), so
        // without this the per-item chevron toggle would have no collapse
        // root class to act on.
        this.hm.behaviors.collapse.createInstances(newListItemElement);

        // Wrap the new list item as a collapsible region via the theme's
        // behaviour adapter (the show-on-add animation). { toggle: false }
        // suppresses the immediate auto-toggle so we control timing.
        let bsCollapse = this.hm.behaviors.collapse.create(newListItemElement, { toggle: false });

        if (afterElement !== false) {
            afterElement.after(newListItemElement);
        } else {
            if (afterIndex === -1) {
                this.subelements.listItemsHolder.append(newListItemElement);
            } else if (afterIndex === -2) {
                this.subelements.listItemsHolder.prepend(newListItemElement);
            }
        }

        newListItem.subComponents = this.hm.app.initComponents(newListItemElement);

        this.initListActions(newListItemElement);

        // Once the expand transition completes, drop the collapse classes so
        // the item is no longer treated as a collapsible region (it's now
        // just a static list item) and dispose the adapter. Subscribe via
        // the adapter's neutral 'shown' event name.
        bsCollapse.on('shown', (ev) => {
            // Resolve the tier's collapse root + shown tokens via the
            // behaviour contract rather than hardcoding Bootstrap literals.
            // .split(' ') because stateClass may return multiple tokens.
            newListItemElement.classList.remove(
                ...this.hm.behaviors.collapse.stateClass('root').split(' '),
                ...this.hm.behaviors.collapse.stateClass('shown').split(' ')
            );
            bsCollapse.dispose();
        });

        bsCollapse.show();

        this.listItems.push(newListItem);
    },

    remove: function (index) {
        if (this.listItems.length <= this.minEntries) {
            let maxReachedMessage = {
                type: 'info',
                text: 'minNoOfItemsReached'
            };
            this.hm.msgs.show(maxReachedMessage);
            return false;
        }

        let toRemove = false;
        let toRemovePos = false;

        for (let i = 0; i < this.listItems.length; i++) {
            if (this.listItems[i].index === index) {
                toRemove = this.listItems[i];
                toRemovePos = i;
                break;
            }
        }

        if (toRemove === false) {
            this.hm.warn('index ' + index + ' not found to remove');
            return false;
        }

        let removedItemId = 0;

        let hiddens = toRemove.element.querySelectorAll('input[type="hidden"]');

        hiddens.forEach((hidden) => {
            if (typeof this.hm.app.components[hidden.id] !== typeof undefined) {
                let hiddenComponent = this.hm.app.components[hidden.id];

                if (typeof hiddenComponent.extraAttributes.editListHiddenType !== typeof undefined && hiddenComponent.extraAttributes.editListHiddenType === 'id') {
                    removedItemId = parseInt(hiddenComponent.getValue());
                }
            }
        });

        if (removedItemId !== 0) {
            let removeComponentId = this.id + '_delete_' + index;
            let removeElement = this.hm.helper.string2element('<input type="hidden" />');
            removeElement.id = removeComponentId;
            removeElement.name = this.elementName() + '_delete[]';
            
            let removeComponent = this.hm.app.newComponent('hidden', removeComponentId, removeElement);

            removeComponent.setValue(removedItemId);

            this.subelements.listItemsHolder.prepend(removeComponent.element);

            this.hm.helper.showElement(this.subelements.deleteWarning);
        }

        toRemove.element.remove();
        this.hm.app.removeComponents(toRemove.subComponents);
        this.listItems.splice(toRemovePos, 1);
    },

    saveSort: async function () {
        this.clearTimer('saveSort_' + this.id);

        let currentListItems = document.querySelectorAll('[data-zit-list-item-for="' + this.id + '"]');

        let sorted = {};

        currentListItems.forEach((currentListItem, newIndex) => {
            let hiddens = currentListItem.querySelectorAll('input[type="hidden"]');

            let currentId = 0;
            let valueChanged = false;

            hiddens.forEach((hidden) => {
                if (typeof this.hm.app.components[hidden.id] !== typeof undefined) {
                    let hiddenComponent = this.hm.app.components[hidden.id];

                    if (typeof hiddenComponent.extraAttributes.editListHiddenType !== typeof undefined) {
                        if (hiddenComponent.extraAttributes.editListHiddenType === 'id') {
                            currentId = parseInt(hiddenComponent.getValue());
                        } else if (hiddenComponent.extraAttributes.editListHiddenType === 'sort') {
                            if (parseInt(hiddenComponent.getValue()) !== newIndex) {
                                valueChanged = true;
                            }
                            hiddenComponent.setValue(newIndex);
                        }
                    }
                }
            });

            if (currentId !== 0 && valueChanged) { //only already saved and the ones with the sort position changed are saved in the background
                sorted[currentId] = newIndex;
            }
        });

        if (Object.keys(sorted).length > 0) {
            let data = {
                configHash: this.configHash,
                componentAction: 'saveSort',
                sorted: sorted
            };

            let response = await this.hm.app.fetchJson('components', 'main', data);
            //maybe display a message that the new order was saved
        }
    }
});


module.exports = editList;